import EmblaCarousel from 'embla-carousel'
import { addDotBtnsAndClickHandlers } from './js/embla-carousel-dots.js'
import { addPrevNextBtnsClickHandlers } from './js/embla-carousel-arrows.js'

// ========= embla ========= //
document.addEventListener("DOMContentLoaded", function() {
   const emblaNodes = document.querySelectorAll('.embla'); // Select all embla instances

   emblaNodes.forEach((emblaNode) => {
      let options = { loop: false };

       if(emblaNode.classList.contains('embla__parceiros')){
         options = {
            breakpoints: {
               '(min-width: 640px)': { slidesToScroll: 4 },
               '(max-width: 640px)': { slidesToScroll: 1 }
             }
         }
       }
       else if(emblaNode.classList.contains('embla__nossotrabalho')){
         options = {
            watchDrag: false
         }
       }

       const emblaApi = EmblaCarousel(emblaNode, options);

       // Handle navigation dots
       const dotsNode = emblaNode.querySelector(':scope > .embla__dots');
       if (dotsNode) {
           const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(emblaApi, dotsNode);
           emblaApi.on('destroy', removeDotBtnsAndClickHandlers);
       }

       // Handle previous/next buttons
       const prevBtnNode = emblaNode.querySelector(':scope > .embla__buttons > .embla__button--prev');
       const nextBtnNode = emblaNode.querySelector(':scope > .embla__buttons > .embla__button--next');
       if (prevBtnNode && nextBtnNode) {
           const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
               emblaApi,
               prevBtnNode,
               nextBtnNode
           );
           emblaApi.on('destroy', removePrevNextBtnsClickHandlers);
       }
   });
});
// ========= /embla ========= //


document.addEventListener('DOMContentLoaded', () => {
    const accordions = document.querySelectorAll('.accordionTrigger');

    accordions.forEach(accordion => {
        accordion.addEventListener('click', () => {
            const content = accordion.querySelector('.accordionContent');
            const icon_faq = accordion.querySelector('.accordionIcon');

            if (content) content.classList.toggle('open');
            
            if (icon_faq && icon_faq.classList.contains('open')){
                content.style.maxHeight = null;
                content.classList.remove("open");

                icon_faq.classList.remove("open");
                icon_faq.classList.add("close");
            }else{
                content.style.maxHeight = content.scrollHeight + 'px';
                content.classList.add("open");

                icon_faq.classList.remove("close");
                icon_faq.classList.add("open");
            }

            if(icon_faq) icon_faq.classList.toggle("rotate-45");
            if(icon_faq) icon_faq.classList.toggle("!text-[#FF4747]");
        });
    });
});